/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, OnInit, AfterViewInit, inject, viewChild, input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingService } from './services/tracking.service';
import { SavedTrackingSearchService, SavedTrackingSearch } from './services/saved-searches.service';
import { ResendDocument, TrackingSharedActionMethodsService } from './services/tracking-shared-action-methods.service';
import { TrackingSearchResult, DistributionObjectContainer } from './models/tracking-search-result';
import { DocumentSearch } from './models/tracking-search-result';
import { BizDataGridDirective, ViewStateChangeEvent } from '../shared/grid/biz-grid.directive';
import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';
import { ToastService } from '../shared/toast/toast.service';
import { DateTimeService } from '../shared/datetime/datetime.service';
import { CurrentUserService } from '../user/services/current-user.service';
import { GenericModalService, ModalSelectElement, ModalSettingsTemplate, SelectMultiChoiceTypes } from '../shared/generic-modal/generic-modal.service';
import { StateService } from '../shared/state-management/state.service';
import { UserSettingsService } from '../user/services';
import { ConfigurationService } from '../configuration/services/configuration.service';
import { TestToolService } from '../test-tool/services/test-tool.service';
import { ViewState } from '../shared/grid/biz-grid-viewstate';
import { CancelMessageDialogComponent } from './cancel-messages-dialog/cancel-message-dialog.component';
import { GridConfigurationService } from '../user/services/grid-configuration.service';
import { AddInterchangeToTestCaseDialogComponent, AddInterchangeToTestCaseDialogResult } from './add-interchange-to-test-case-dialog/add-interchange-to-test-case-dialog.component';
import { TrackingUiAction } from '../developer/models/tracking-ui-action';
import { RunTrackingUiActionDialogComponent } from './run-tracking-ui-action-dialog/run-tracking-ui-action-dialog.component';
import { TrackingActionDocument } from './models/tracking-action-document';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { RestrictedSearchCalloutComponent, RestrictedSearchCalloutType } from '../shared/restricted-search/restricted-search.component';

import { FormsModule } from '@angular/forms';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { TrackingStatusLabelComponent } from './tracking-status-label.component';
import { TrackingDocumentStylesheetService } from './services/tracking-document-stylesheet.service';
import { DistributionObjectService } from '../distribution/services';

@Component({
    templateUrl: './tracking-search-result.component.html',
    styleUrls: ['./tracking-search-result.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PermissionRequiredDirective, SvgIconComponent, RestrictedSearchCalloutComponent, FormsModule, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, DxDataGridModule, BizDataGridDirective, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, TrackingStatusLabelComponent]
})
export class TrackingSearchResultComponent implements AfterViewInit, OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private toastService = inject(ToastService);
    private trackingService = inject(TrackingService);
    private configurationService = inject(ConfigurationService);
    public dateTimeService = inject(DateTimeService);
    private modalService = inject(GenericModalService);
    private trackingSharedActionMethodsService = inject(TrackingSharedActionMethodsService);
    private loadingPanelService = inject(LoadingPanelService);
    private stateService = inject(StateService);
    private testToolService = inject(TestToolService);
    private savedTrackingSearchService = inject(SavedTrackingSearchService);
    private currentUserService = inject(CurrentUserService);
    private userSettingsService = inject(UserSettingsService);
    private gridConfigurationService = inject(GridConfigurationService);
    private trackingDocumentStylesheetService = inject(TrackingDocumentStylesheetService);
    private distributionObjectService = inject(DistributionObjectService);

    private datagrid = viewChild(BizDataGridDirective);
    readonly RestrictedSearchCalloutType = RestrictedSearchCalloutType;
    readonly trackingFieldPrefix: string = 'trackingField_';
    readonly stateKey: string = 'tracking-search-result-state';

    public stateObject = new TrackingResultStateObject();
    public mode = input<string>('details');
    public showFilterRow = false; 
    public trackingUiActions: TrackingUiAction[] = [];

    private defaultViewStateId?: number;
    private autoOpen = false;
    private stateLoaded = false;
    private limitedActionNumber: number; // This should be set later on nginit, used for resending, manually handled, delete etc.

    currentViewState: ViewState | null = null;

    ngOnInit(): void {
        void this.gridConfigurationService.getDefaultViews('Tracking').then(views => {
            if (views.length > 0) {
                this.defaultViewStateId = views[0].Id;
            }
        });

        void this.trackingService.getTrackingUiActionsForTrackingResultPage().then(result => this.trackingUiActions = result);

        this.route.params.subscribe((parms: any) => {
            this.autoOpen = parms.searchType?.toLowerCase() === 'direct';

            const stateObject = this.stateService.getState(this.stateKey);
            if (stateObject) {
                // TODO: Is there a better way to compare two objects without comparing the object-reference?
                // This is fast but not scalable.The order of the properties must be the same using this method.
                const previousParms = JSON.stringify(stateObject.parms);
                const currentParms = JSON.stringify(parms);
                this.stateLoaded = previousParms === currentParms;
            }

            if (this.stateLoaded) {
                this.stateObject = stateObject;
            }
            else {
                this.stateObject = new TrackingResultStateObject();
                this.stateObject.parms = parms;
                this.stateObject.pendingApplyDefaultViewState = !stateObject;

                // Reset undesired state in the grid; if any
                const gridState = this.datagrid().loadGridState();
                if (gridState) {
                    delete gridState.selectedRowKeys;
                    delete gridState.searchText;
                    delete gridState.pageIndex;
                    this.datagrid().saveGridState(gridState);
                }
            }

            if (parms.isSavedSearch) {
                this.refresh();
            }
            this.configurationService.getEffectiveSettingValue('TrackingSearch_ActionWarningThreshold').then(result => {
                if (result) {
                    this.limitedActionNumber = +result;
                }
            });

            this.userSettingsService.getSingleSetting('Setting_Grid_ShowFilterRow').then(setting => {
                if (setting) {
                    this.showFilterRow = setting.Value1 === 'true';
                }
            });
        });
    }

    ngAfterViewInit(): void {
        this.initializeContextMenu();
        this.datagrid().rowDoubleClick.subscribe((row) => {
            if (this.currentUserService.hasPermission('Tracking_View_DocumentDetails')) {
                this.showGivenDocuments([row]);
            }
        });

        if (!this.stateLoaded && !this.stateObject.parms.isSavedSearch) {
            this.refresh();
        }
    }

    initializeContextMenu() {
        this.datagrid().instance.option('onContextMenuPreparing', (e) => {
            if (e.row && e.row.rowType === 'data') {
                if (this.stateObject.selectedRows.length > 0) {

                    const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map(r => r.InterchangeInId);

                    e.items = [];

                    e.items.push({
                        text: 'Show selected document(s)',
                        onItemClick: () => {
                            this.showDocuments();
                        }
                    });

                    if (interchangeInIds.length === 0) {
                        e.items.push({
                            text: 'Show document guids for selected document(s)',
                            onItemClick: () => {
                                const guids = this.stateObject.selectedRows.map((r) => r.DocumentGuid);
                                const guidString = guids.join(', ');
                                const html = '<pre>' + guidString + '</pre>';
                                this.modalService.messageDirect('Document Guids', html);
                            }
                        });
                    }

                    if (this.currentUserService.hasPermission('TestTool_Action_TestCase_Edit')) {
                        if (this.stateObject.selectedRows.every(r => r.DocumentId !== null)) {
                            e.items.push({
                                text: 'Add to test case',
                                onItemClick: () => this.addToTestCase()
                            });
                        }
                    }

                    if (this.currentUserService.hasPermission('Tracking_Action_ExportFilesZipped')) {
                        e.items.push({
                            text: 'Export selected documents',
                            onItemClick: () => {
                                this.export();
                            }
                        });
                    }

                    if (this.currentUserService.hasPermission('Tracking_Action_DeleteMultipleDocuments')) {
                        e.items.push({
                            text: 'Delete selected documents',
                            onItemClick: () => {
                                this.delete();
                            }
                        });
                    }

                    if (this.stateObject.selectedRows.length === 1) {
                        const row = this.stateObject.selectedRows[0];

                        if (row.DistributionId > 0) {
                            e.items.push({
                                text: 'Show distribution',
                                onItemClick: () => {
                                    const parms = { distributionIds: row.DistributionId };
                                    this.router.navigate(['distribution/result/details', parms]);
                                }
                            });
                        }
                        else if (row.PartnerFromEdiPortalId && row.PartnerToEdiPortalId && row.DistributionObjectName) {
                            e.items.push({
                                text: 'Search distributions for selected document (from-partner, to-partner and document type)',
                                onItemClick: () => {
                                    const parms = {
                                        distributionObjectId: row.DistributionObjectId,
                                        partnerFromId: row.PartnerFromId,
                                        partnerToId: row.PartnerToId
                                    };

                                    this.router.navigate(['distribution/result', parms]);
                                }
                            });
                        }

                        if (row.PartnerToId) {
                            e.items.push({
                                text: 'Show to-partner for selected document',
                                onItemClick: () => {
                                    const parms = { partnerIds: [row.PartnerToId] };
                                    this.router.navigate(['partner/details', parms]);
                                }
                            });
                        }

                        if (row.PartnerFromId) {
                            e.items.push({
                                text: 'Show from-partner for selected document',
                                onItemClick: () => {
                                    const parms = { partnerIds: [row.PartnerFromId] };
                                    this.router.navigate(['partner/details', parms]);
                                }
                            });
                        }
                    }

                    if (this.currentUserService.hasPermission('Tracking_Action_ExecuteILinkTrackingAction')) {
                        this.trackingUiActions.forEach(a => {
                            e.items.push({
                                text: a.Name,
                                onItemClick: () => {
                                    this.runTrackingUiAction(a);
                                }
                            });
                        });
                    }
                }
            }
        });
    }

    async refresh(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading documents...');

            const result = await this.trackingService.searchDocuments(this.stateObject.parms);
            if (result) {
                this.processSearchResult(result);
                await this.handleDeepLinkLogic(result);
                this.datagrid().instance.clearSelection();
            }
        } catch {
            // Ignore
        } finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    // #region Process Search Result
    private processSearchResult(result: TrackingSearchResult): void {
        this.sortDistributionGroups(result);
        this.filterTrackingFields(result);
        this.formatDocumentDates(result);

        const anyPreviousSelected = this.selectPreviousGroups(result);

        this.stateObject.searchResult = result;

        if (!anyPreviousSelected && result.DistributionGroups.length > 0) {
            this.selectMostRecentDistributionObjectContainer(result);
        }

        this.selectedGroupsChanged();
        this.stateService.setState(this.stateKey, this.stateObject);

        if (!this.stateLoaded) {
            setTimeout(() => {
                this.datagrid().instance.refresh();
                this.datagrid().reapplyViewState();
            }, 1);
        } 
    }

    private sortDistributionGroups(result: TrackingSearchResult): void {
        result.DistributionGroups.sort((dg1, dg2) => dg1.DistributionObjectGroupName.localeCompare(dg2.DistributionObjectGroupName));
    }

    private filterTrackingFields(result: TrackingSearchResult): void {
        result.DistributionGroups.forEach(distGrp => {
            distGrp.DistributionObjectContainers.forEach(distObjC => {
                distObjC.TrackingFields = distObjC.TrackingFields.filter(tf => tf['ShowInSearchPreview'] === true);
            });
        });
    }

    private formatDocumentDates(result: TrackingSearchResult): void {
        result.DistributionGroups.forEach(distGrp => {
            distGrp.DistributionObjectContainers.forEach(distObjC => {
                distObjC.Documents.forEach(doc => {
                    doc['FormatVariantVersionFrom'] = `${doc.FormatNameIn || ''}/${doc.VariantNameIn || ''}/${doc.VariantVersionIn || ''}`.replace('//', '');
                    doc['FormatVariantVersionTo'] = `${doc.FormatNameOut || ''}/${doc.VariantNameOut || ''}/${doc.VariantVersionOut || ''}`.replace('//', '');
                    doc.CreatedDate = new Date(doc.CreatedDate);
                    doc['CleanDate'] = new Date(doc.CreatedDate.getFullYear(), doc.CreatedDate.getMonth(), doc.CreatedDate.getDate());
                });
            });
        });
    }

    private selectPreviousGroups(result: TrackingSearchResult): boolean {
        let anyPreviousSelected = false;
        if (this.stateObject.searchResult) {
            this.stateObject.searchResult.DistributionGroups.filter(dg => dg['selected'] === true).forEach(dg => {
                const existingGroup = result.DistributionGroups.find(d => d.DistributionObjectGroupId === dg.DistributionObjectGroupId);
                if (existingGroup) {
                    existingGroup['selected'] = true;
                    anyPreviousSelected = true;
                }
            });
        }
        return anyPreviousSelected;
    }

    private selectMostRecentDistributionObjectContainer(result: TrackingSearchResult): void {
        let mostRecentDistributionObjContainer: DistributionObjectContainer = null;
        result.DistributionGroups.forEach(distGrp => {
            distGrp['selected'] = true;
            distGrp.DistributionObjectContainers.forEach(dObjContainer => {
                if (dObjContainer.Documents.length > 0) {
                    if (mostRecentDistributionObjContainer === null || dObjContainer.Documents[0].CreatedDate > mostRecentDistributionObjContainer.Documents[0].CreatedDate) {
                        mostRecentDistributionObjContainer = dObjContainer;
                    }
                }
            });
        });

        if (mostRecentDistributionObjContainer != null) {
            this.stateObject.selectedDistributionObjectContainer = mostRecentDistributionObjContainer;
        }
    }

    selectedGroupsChanged(): void {
        this.stateObject.distributionObjectsContainers = [];
        this.stateObject.searchResult.DistributionGroups
            .filter((g: any) => g.selected === true) // Get all selected groups
            .forEach(g => this.stateObject.distributionObjectsContainers = this.stateObject.distributionObjectsContainers.concat(g.DistributionObjectContainers));
        // Get all distributionObjects from selected groups

        this.stateObject.distributionObjectsContainers.sort((dc1, dc2) => dc1.DistributionObjectName.localeCompare(dc2.DistributionObjectName)); // Sort the array by distribution-object-name

        if (this.stateObject.distributionObjectsContainers.length > 1) { // Only show "Show all" if there are more than one distribution-object to show
            let allDocuments = [];
            let trackingFields = [];
            this.stateObject.distributionObjectsContainers.forEach(doc => { allDocuments = allDocuments.concat(doc.Documents); trackingFields = trackingFields.concat(doc.TrackingFields); });

            const allDistributionObjectContainer: DistributionObjectContainer = {
                DistributionObjectName: 'Show All',
                DistributionObjectId: -1,
                DistributionObjectDescription: 'Show All',
                Documents: allDocuments,
                TrackingFields: trackingFields
            };
            this.stateObject.distributionObjectsContainers.push(allDistributionObjectContainer);
        }

        // If there is a previous selected distribution-object - find the correct object-reference in the new result.
        if (this.stateObject.selectedDistributionObjectContainer) {
            this.stateObject.selectedDistributionObjectContainer = this.stateObject.distributionObjectsContainers.find(doc =>
                doc.DistributionObjectId === this.stateObject.selectedDistributionObjectContainer.DistributionObjectId);
        }
        // If no previously selected - select the first distribution-object
        if (!this.stateObject.selectedDistributionObjectContainer && this.stateObject.distributionObjectsContainers.length > 0) {
            this.stateObject.selectedDistributionObjectContainer = this.stateObject.distributionObjectsContainers[0];
        }

        this.selectedDistributionObjectsChanged();
    }

    // #endregion

    // #region DeepLink Logic
    private async handleDeepLinkLogic(result: TrackingSearchResult): Promise<void> {
        const parmsDirectExists = this.stateObject.parms.direct !== undefined;

        if (result.TotalCount === 1 && !parmsDirectExists) {
            await this.handleSingleDocument(result);
        } else if (parmsDirectExists) {
            this.handleMultipleDocuments(result);
        }
        else {
            //this will result in list of documents grid with multible documents.
        }
    }

    private async handleSingleDocument(result: TrackingSearchResult): Promise<void> {
        const documentId = result?.DistributionGroups[0]?.DistributionObjectContainers[0]?.Documents[0]?.DocumentId;

        if (this.autoOpen) {
            await this.handleModeNavigation(result, documentId);
        }
        else {
            //this will result in list of documents grid with 1 document.
        }
    }

    private async handleModeNavigation(result: TrackingSearchResult, documentId: number): Promise<void> {
        //DeepLinkExampel: 
        // tracking/result;documentGuid=3d605b72-3a7d-4c6f-94eb-bd53f69dee65;searchType=direct
        // tracking/result;documentGuid=3d605b72-3a7d-4c6f-94eb-bd53f69dee65;searchType=direct;mode=stylesheet
        switch (this.mode()) {
            case 'stylesheet': {
                const cdmFileGuid = (await this.trackingService.getDocuments([documentId], []))?.Documents[0]?.FileGuidCdm;
                const distributionObjectId = result?.DistributionGroups[0]?.DistributionObjectContainers[0]?.DistributionObjectId;
                const stylesheetIdentifier = (await this.distributionObjectService.getDistributionObjects()).find(d => d.Id === distributionObjectId)?.CdmStylesheetArtifactId;

                if (!this.guidIsNullOrEmpty(cdmFileGuid) && !this.guidIsNullOrEmpty(stylesheetIdentifier)) {
                    window.location.href = await this.getStylesheetUrl(cdmFileGuid, stylesheetIdentifier);
                }
                else {
                    await this.router.navigate(['tracking/result/details', { documentIds: documentId }]);//fallback to details view 
                }
                break;
            }

            case 'details':
            default:
                await this.router.navigate(['tracking/result/details', { documentIds: documentId }]);//fallback to details view
                break;
        }
    }

    private handleMultipleDocuments(result: TrackingSearchResult): void {
        //DeepLink Exampel tracking/result;interchangeGuid=7018cff1-d70f-48c6-802d-4273ab835289;direct
        const documentList = result.DistributionGroups.flatMap(dg => dg.DistributionObjectContainers).flatMap(d => d.Documents);
        this.showGivenDocuments(documentList);
    }

    private async getStylesheetUrl(fileIdentifier: string, stylesheetIdentifier: string): Promise<string> {
        const token = await this.trackingDocumentStylesheetService.getStylesheetToken(fileIdentifier, stylesheetIdentifier);
        return '/api/tracking/stylesheet/get-stylesheet-show-data/' + token;
    }
    // #endregion

    private guidIsNullOrEmpty(guid: string): boolean {
        return !guid || guid === '00000000-0000-0000-0000-000000000000';
    }

    selectedDistributionObjectsChanged(): void {
        const gridState = this.datagrid().instance.state();

        if (this.stateObject.selectedDistributionObjectContainer) {

            this.stateObject.showDistributionObjectColumn = this.stateObject.selectedDistributionObjectContainer.DistributionObjectId === -1;
            this.stateObject.documents = this.stateObject.selectedDistributionObjectContainer.Documents || [];

            this.datagrid().setSummary();

            // Set tracking-field values
            this.stateObject.documents.forEach(document => {
                if (document.TrackingFields) {
                    document.TrackingFields.forEach(tf => document[this.trackingFieldPrefix + tf.TrackingFieldTypeId] = tf.TrackingFieldValue);
                }
            });
        }
        else {
            this.stateObject.documents = [];
        }

        setTimeout(() => {
            if (gridState?.columns) {
                const column = gridState.columns.find(e => e.dataField === 'DistributionObjectName');
                if (column) {
                    column.visible = this.stateObject.showDistributionObjectColumn;
                }
                this.datagrid().instance.state(gridState);
            }
        }, 1);
    }

    gridResetButtonPressed(): void {
        this.selectedDistributionObjectsChanged();
    }

    selectionChanged(e: any): void {
        this.stateObject.selectedRows = e.selectedRowsData;
    }
    
    async resend(): Promise<void> {
        try {
            if (this.stateObject.selectedRows.length > 0) {
                const documentResends = this.stateObject.selectedRows.map<ResendDocument>(r => ({ documentId: r.DocumentId, interchangeInId: r.InterchangeInId }));
                await this.trackingSharedActionMethodsService.resend(documentResends, this.stateObject.selectedRows.length);
                this.refresh();
            }
        } catch {
            // Ignore
        }
    }

    async handleManually(): Promise<void> {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);

        if (((documentIds && (documentIds.length > 0)) || (interchangeInIds && (interchangeInIds.length > 0)))
            && (await this.checkLimitedActionNumber(documentIds.length + interchangeInIds.length, 'manually handle'))) {
            await this.trackingSharedActionMethodsService.handleManually(documentIds, interchangeInIds);
            this.refresh();
        }
    }

    async onHold(): Promise<void> {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);

        if (((documentIds && (documentIds.length > 0)) || (interchangeInIds && (interchangeInIds.length > 0)))
            && (await this.checkLimitedActionNumber(documentIds.length + interchangeInIds.length, 'on hold'))) {
            await this.trackingSharedActionMethodsService.setDocumentsOnHold(documentIds, interchangeInIds);
            this.refresh();
        }
    }

    showDocuments(): void {
        this.showGivenDocuments(this.stateObject.selectedRows);
    }

    showGivenDocuments(documentsToShow: any[]): void {
        const documentIds = documentsToShow
            .filter(r => r.DocumentId !== undefined && r.DocumentId !== null)
            .map<number>(r => r.DocumentId)
            .filter((val, idx, self) => self.indexOf(val) === idx); // distinct;

        const interchangeInIds = documentsToShow
            .filter(r => r.DocumentId === undefined || r.DocumentId === null)
            .map<number>(r => r.InterchangeInId)
            .filter((val, idx, self) => self.indexOf(val) === idx); // distinct;

        if (documentIds.length > 0 || interchangeInIds.length > 0) {

            if ((documentIds.length + interchangeInIds.length) > TrackingService.maxNumberOfDocumentsToShow) {
                const maxDocuments = TrackingService.maxNumberOfDocumentsToShow;
                this.modalService.messageDirect('Maximum number of documents', `Maximum number of documents to show is ${maxDocuments}`);
            }
            else {
                const searchIdObject = {};

                if (documentIds.length > 0) {
                    searchIdObject['documentIds'] = documentIds.join(',');
                }

                if (interchangeInIds.length > 0) {
                    searchIdObject['interchangeInIds'] = interchangeInIds.join(',');
                }

                this.router.navigate(['tracking/result/details', searchIdObject]);
            }
        }
    }

    async addToTestCase(): Promise<void> {
        const selectedInterchangeInIds = this.stateObject.selectedRows
            .filter(e => e.InterchangeInId !== null)
            .map(e => e.InterchangeInId);

        const interchangeInIds = [...new Set(selectedInterchangeInIds)];

        try {
            const modalSettings = new ModalSettingsTemplate('lg', 'static');
            const componentValues = { interchangeInIds };
            const result: AddInterchangeToTestCaseDialogResult = await this.modalService.openComponent(AddInterchangeToTestCaseDialogComponent, componentValues, modalSettings);

            await this.testToolService.addInterchangesToTestCase(result.testCase.Id, result.interchangeIds, result.selectedOutputType);

            this.datagrid().instance.refresh(); // Needed for the datagrid to show the new data...

            const interchangeCount = result.interchangeIds.length;
            if (interchangeCount < 2) {
                this.modalService.messageDirect('Interchange added to test case', `One Interchange added to test case '${result.testCase.Name}'.`).catch(() => { });
            }
            else {
                this.modalService.messageDirect('Interchanges added to test case', `${interchangeCount} interchanges are added to test case '${result.testCase.Name}'.`).catch(() => { });
            }
        }
        catch (err) {
            let errMsg = '';
            if (err) {
                errMsg = `No interchanges added to test case.<br><br>${err?.error}`;
            }
            else {
                errMsg = 'No interchanges added to test case';
            }

            this.modalService.messageDirect('Operation cancelled', errMsg).catch(() => { });
        }
    }

    async runTrackingUiAction(action: TrackingUiAction): Promise<void> {
        const componentValues = {
            trackingUiAction: action,
            trackingActionDocuments: this.stateObject.selectedRows.map(row => this.toTrackingActionDocument(row)),
        };

        try {
            const modalSettings = new ModalSettingsTemplate('lg', 'static');
            await this.modalService.openComponent(RunTrackingUiActionDialogComponent, componentValues, modalSettings);
        }
        catch {
            // Ignore
        }
        await this.refresh();
    }

    toTrackingActionDocument(ds: DocumentSearch): TrackingActionDocument {
        return !ds ? null : {
            InterchangeInId: ds.InterchangeInId,
            InterchangeInNumber: ds.InterchangeInNumber,
            InterchangeInOriginatingId: ds.InterchangeOriginatingId,
            TransmissionIdIn: ds.TransmissionIdIn,
            DocumentId: ds.DocumentId,
            DocumentNumber: ds.DocumentNumber,
            DocumentOriginatingId: ds.DocumentOriginatingId,
            LatestDocumentStatus: ds.LastStatus,
            PartnerSystem: !ds.PartnerSystemInId ? null : {
                PartnerSystemId: ds.PartnerSystemInId,
                Key: ds.PartnerSystemInKey,
                Name: ds.PartnerSystemInName,
            },
            DocumentType: !ds.DistributionObjectId ? null : {
                DocumentTypeId: ds.DistributionObjectId,
                Name: ds.DistributionObjectName,
            },
            PartnerIn: !ds.PartnerFromId ? null : {
                PartnerId: ds.PartnerFromId,
                Name: ds.PartnerFrom,
                PartnerKey: ds.PartnerFromEdiPortalId,
            },
            PartnerOut: !ds.PartnerToId ? null : {
                PartnerId: ds.PartnerToId,
                Name: ds.PartnerTo,
                PartnerKey: ds.PartnerToEdiPortalId,
            },
            DocumentConfigIn: !(ds.FormatNameIn || ds.VariantNameIn || ds.VariantVersionIn) ? null : {
                FormatName: ds.FormatNameIn,
                VariantName: ds.VariantNameIn,
                VariantVersionName: ds.VariantVersionIn,
            },
            DocumentConfigOut: !(ds.FormatNameOut || ds.VariantNameOut || ds.VariantVersionOut) ? null : {
                FormatName: ds.FormatNameOut,
                VariantName: ds.VariantNameOut,
                VariantVersionName: ds.VariantVersionOut,
            },
        } as TrackingActionDocument;
    }

    canCancelMessage(): boolean {
        return (this.stateObject.selectedRows?.length > 0 && this.stateObject.selectedRows
            .every(e => e.LastStatus === 'Inbox' || e.LastStatus === 'Initializing' || e.LastStatus === 'Processing' || e.LastStatus === 'Batching' || e.LastStatus === 'Outbox'));
    }

    async cancelMessage(): Promise<void> {
        const interchangeInIds = this.stateObject.selectedRows
            .filter(e => e.InterchangeInId !== null && e.DocumentId === null && e.InterchangeOutId === null && e.LastStatus !== 'Failed')
            .map(e => e.InterchangeInId);

        const documentIds = this.stateObject.selectedRows
            .filter(e => e.DocumentId !== null && e.InterchangeOutId === null && e.LastStatus !== 'Failed')
            .map(e => e.DocumentId);

        const interchangeOutIds = this.stateObject.selectedRows
            .filter(e => e.InterchangeOutId !== null && e.LastStatus !== 'Completed' && e.LastStatus !== 'Failed')
            .map(e => e.InterchangeOutId);

        try {
            const modalSettings = new ModalSettingsTemplate(null, 'static');
            const componentValues = { interchangeInIds, documentIds, interchangeOutIds };
            await this.modalService.openComponent(CancelMessageDialogComponent, componentValues, modalSettings);

            this.datagrid().instance.refresh(); // Needed for the datagrid to show the new data...
        }
        catch {
            // Ignore
        }
    }

    async export(): Promise<void> {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);
        const boolvalue = await this.checkLimitedActionNumber(documentIds.length + interchangeInIds.length, 'export');
        if (boolvalue) {
            if (documentIds.length > 0 || interchangeInIds.length > 0) {
                const elements: ModalSelectElement[] = [];
                elements.push(new ModalSelectElement('Interchange In', 'InterchangeIn'));
                elements.push(new ModalSelectElement('Message In', 'MessageIn'));
                elements.push(new ModalSelectElement('CDM', 'MessageCdm'));
                elements.push(new ModalSelectElement('Interchange Out', 'InterchangeOut'));

                this.modalService.selectMultiChoiceDirect('Export', 'Select the type of files to export:',
                    elements, undefined, SelectMultiChoiceTypes.CheckBoxes).then((chosenElements: ModalSelectElement[]) => {
                        const selectedFileTypes: string[] = chosenElements.map((e) => e.value);
                        if (selectedFileTypes.length > 0) {
                            this.loadingPanelService.showLoadingPanel(new LoadingPanelSettings('Preparing export...'));
                            this.trackingService.downloadZipFile(documentIds, interchangeInIds, selectedFileTypes).then(() => {
                                this.loadingPanelService.hideLoadingPanel();
                            }).catch(() => { this.loadingPanelService.hideLoadingPanel(); });
                        }
                    }).catch(() => { });
            }
        }
    }

    async compareDocuments(): Promise<void> {
        const selectedRows = this.stateObject.selectedRows;
        switch (selectedRows.length) {
            case 1:
                try { await this.modalService.messageDirect('Compare files', 'Choose one more file to compare'); }
                catch { /* Ignore */ }
                break;

            case 2: {
                const [leftDocument, rightDocument] = [...selectedRows];
                const commands: any = {};

                if (leftDocument?.DocumentId != null) {
                    commands.leftDocumentId = leftDocument.DocumentId;
                }
                else if (leftDocument?.InterchangeInId != null) {
                    commands.leftInterchangeInId = leftDocument.InterchangeInId;
                }

                if (rightDocument?.DocumentId != null) {
                    commands.rightDocumentId = rightDocument.DocumentId;
                }
                else if (rightDocument?.InterchangeInId != null) {
                    commands.rightInterchangeInId = rightDocument.InterchangeInId;
                }

                await this.router.navigate(['tracking/result/compare', commands]);
                break;
            }

            default:
                try { await this.modalService.messageDirect('Compare files', 'Only two files can be chosen at a time for comparison'); }
                catch { /* Ignore */ }
        }
    }

    async delete(): Promise<void> {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);

        if (((documentIds.length > 0) || interchangeInIds.length > 0) && (await this.checkLimitedActionNumber(documentIds.length + interchangeInIds.length, 'delete'))) {
            this.modalService.confirmDirect('Delete documents', 'Are you sure you want to delete the selected documents?').then(() => {
                this.loadingPanelService.showLoadingPanelDirect('Deleting documents...');
                this.trackingService.deleteDocuments(documentIds, interchangeInIds).then(() => {
                    this.loadingPanelService.hideLoadingPanel();
                    this.refresh();
                }).catch(() => {
                    this.loadingPanelService.hideLoadingPanel();
                });
            }).catch(() => { });
        }
    }

    async recreate(): Promise<void> {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);
        const boolvalue = await this.checkLimitedActionNumber(documentIds.length + interchangeInIds.length, 'recreate');
        if (boolvalue) {
            if (documentIds.length > 0 || interchangeInIds.length > 0) {
                this.trackingSharedActionMethodsService.recreate(documentIds, interchangeInIds).then(() => {

                }).catch(() => { });
            }
        }
    }

    changeStakeholder(): void {
        const documentIds = this.stateObject.selectedRows.map<number>((r) => r.DocumentId);
        const interchangeInIds = this.stateObject.selectedRows.filter(row => row.DocumentId == null).map<number>((r) => r.InterchangeInId);
        if (documentIds.length > 0 || interchangeInIds.length > 0) {
            this.trackingSharedActionMethodsService.changeStakeholder(documentIds, interchangeInIds).then(() => {
                this.refresh();
            }).catch(() => { });
        }
    }

    saveSearch(): void {
        this.modalService.inputDirect('Save search', 'Enter a name for this search').then((name) => {
            if (name) {
                this.savedTrackingSearchService.saveSearch(new SavedTrackingSearch(name, this.stateObject.parms)).then(() => {
                    this.modalService.messageDirect('Saved', 'The search is now saved').then(() => { }).catch(() => { });
                });
            }
        }).catch(() => { });
    }

    async checkLimitedActionNumber(numberSelected: number, type: string): Promise<boolean> {
        if (this.limitedActionNumber && (numberSelected >= this.limitedActionNumber)) {
            try {
                await this.modalService.confirmDirect('Please confirm',
                    'Do you want to ' + type + ' ' + numberSelected + ' documents', 'Yes', 'No');
                return true;
            }
            catch {
                // We get here if the confirm dialog is canceled
                return false;
                
            }
        }
        return true;
    }

    onViewStateChanging($event): void {
        if (this.stateObject.pendingApplyDefaultViewState) {
            this.stateObject.pendingApplyDefaultViewState = false;

            if (this.defaultViewStateId) {
                $event.viewState = this.datagrid().selectViewState(this.defaultViewStateId);
            }
        }
    }

    onViewStateChanged($event: ViewStateChangeEvent): void {
        this.currentViewState = $event.viewState;
    }

    showChangeStakeholder(): boolean {
        const documents = this.stateObject.documents ?? [];
        return documents.length > 0 && documents.some(doc => doc.LastStatus === 'Failed');
    }

    disableChangeStakeholder(): boolean {
        const rows = this.stateObject.selectedRows ?? [];
        return rows.length === 0 || rows.some(doc => doc.LastStatus !== 'Failed');
    }
}

class TrackingResultStateObject {
    public documents: DocumentSearch[] = [];
    public searchResult: TrackingSearchResult;
    public distributionObjectsContainers: DistributionObjectContainer[] = [];
    public selectedDistributionObjectContainer: DistributionObjectContainer;
    public showDistributionObjectColumn: boolean;
    public selectedRows: DocumentSearch[] = [];
    public parms: any;
    public pendingApplyDefaultViewState: boolean;  
}
 